import React from "react";
import { Link } from "react-router-dom";
import { PRODUCT_NEXT_STEP } from "../../utility/marketingProductNav";

const ProductNextStep = ({ pathname }) => {
  const next = PRODUCT_NEXT_STEP[pathname];
  if (!next) return null;

  return (
    <aside className="mt-14 max-w-2xl card-board p-6">
      <p className="text-sm font-display font-bold tracking-widest uppercase text-brand-charcoal">
        Next step
      </p>
      <h2 className="mt-2 font-display font-bold text-xl text-brand-charcoal tracking-tight">
        <Link to={next.to} className="underline text-brand-gold-ink">
          {next.label}
        </Link>
      </h2>
      <p className="mt-2 text-sm text-brand-muted">{next.detail}</p>
    </aside>
  );
};

export default ProductNextStep;
